import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosError } from "axios";
import { useMutation } from "@tanstack/react-query";
import { EstablishmentDisableValidationSchema } from "../schemas/enableDisableEstablishment.schema";

interface UseDisableEstablishmentProps {
  establishmentId?: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

const useDisableEstablishment = ({ establishmentId, onSuccess, onError }: UseDisableEstablishmentProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation<void, AxiosError, EstablishmentDisableValidationSchema>({
    mutationKey: ['disableEstablishment', establishmentId],
    mutationFn: (data) => privateAxios.put(`/establishment/companies/${establishmentId}/disable`, {
      company: {
        reason: data.disable_reason,
      },
    }),
    onSuccess,
    onError,
  });
};

export default useDisableEstablishment;
